var m = require('mithril');
var layout = require('../layout/layout');
var networks = require('./networks');
var agentMetricsPage = require('./components/agentMetricsPage');
var bacnetConnections = require('./bacnetConnections');

var routes = {
  '/networks': {
    view: function() {
      return m(layout, m(networks));
    }
  },
  '/agent': {
    view: function() {
      return m(layout, m(agentMetricsPage));
    }
  },
  '/bacnet-connections': {
    view: function() {
      return m(layout, m(bacnetConnections));
    }
  },
}

module.exports = routes;
